import { UserService } from 'src/app/services/user/user.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { NotificationService } from 'src/app/services/notification/notification.service';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-enterprise-notification-user-modal',
  templateUrl: './enterprise-notification-user-modal.component.html',
  styleUrls: ['./enterprise-notification-user-modal.component.css'],
})
export class EnterpriseNotificationUserModalComponent implements OnInit {
  users: any[];
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  color1: string;
  color2: string;
  loading: boolean = false;
  title: string;
  idEnterprise: number;
  idUser: number;
  selectedUser = '';
  inputEmail = '';
  email = '';

  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<EnterpriseNotificationUserModalComponent>,
    private userService: UserService,
    private notificationService: NotificationService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public alert: any
  ) {}

  ngOnInit() {
    // console.log(this.alert);
    this.title = AppConstants.TitleModal.ADD_NEW_EMAIL_FOR_ALERT;
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.enterpriseSelect = +localStorage.getItem(
      AppConstants.Session.ENTERPRISE
    );
    this.headquarterSelect = +localStorage.getItem(
      AppConstants.Session.HEADQUARTER
    );
    this.idEnterprise = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
    this.idUser = +localStorage.getItem(AppConstants.Session.USERID);
    this.userList();
  }

  //LLENAMOS EL CORREO
  onUserSelect(event: any) {
    if (event.target.value) {
      this.inputEmail = '';
      this.email = event.target.value;
      console.log(this.email);
    }
  }
  onEmailInput(event: any) {
    if (event.target.value) {
      this.selectedUser = '';
      this.email = event.target.value;
      console.log(this.email);
    }
  }

  // TRAEMOS LOS USUARIOS DE LA SEDE
  userList() {
    this.users = [];
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
    };
    this.spinner.show();
    this.userService.getUserEnterpriseHeadquarters(filter).subscribe(
      (response) => {
        if (response.error == null) {
          this.users = response.data;
          if(this.users.length > 0){
            this.selectedUser = this.users[0].username;
          }
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  //AGREGAMOS EL EMAIL PARA ALERTAS
  addMail() {
    var users = this.alert.alert.emails;
    if (users) {
      users += ',' + this.email;
    } else {
      users = this.email;
    }

    var payload = {
      idUser: this.idUser,
      idEnterprise: this.idEnterprise,
      emails: users,
      idAlertType: this.alert.alert.idAlertType,
      email: this.email,
      insert: 1,
    };
    this.notificationService
      .updateEnterpriseSettingEmail(payload)
      .subscribe(
        (response) => {
          if(response.message){
            this.alertService.showMessage(
              response.message,
              "",
              MessageSeverity.error
            );
          }else{
            this.dialogRef.close({add:true,emails: users});
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }
}
